import { useEffect, useCallback, Fragment } from 'react';
import Header from './Header';
import Month from './Month';
import Week from './Week';
import { CAL_TYPE } from '@features/calendar/core';
import { setType, setDrawDate, selectedType, selectedSelectedDate } from '@features/calendar/CalendarSlice';
import { DEVICE_TYPE } from '@constants/index';
import { getDevice } from '@utils/index';
import { useAppDispatch, useAppSelector } from '@hooks/defineRtkTypedHook';
import type { IL10n, IDataByDateMap } from '@type/index';

interface ICalendarProps {
  l10n: IL10n;
  dataByDateMap: IDataByDateMap;
  isShowCalendarMark: boolean;
}

const device = getDevice();
const isPc = device === DEVICE_TYPE.PC;

const Calendar = ({ l10n, dataByDateMap, isShowCalendarMark }: ICalendarProps) => {
  const dispatch = useAppDispatch();
  const type = useAppSelector(selectedType);
  const selectedDate = useAppSelector(selectedSelectedDate);

  // 선택한 날짜가 변경되면 달력을 그리는 drawDate(focus date)도 변경하도록
  useEffect(() => {
    dispatch(setDrawDate(selectedDate));
  }, [selectedDate]);

  const btnClickCallback = useCallback(() => {
    dispatch(setType(type === CAL_TYPE.WEEK ? CAL_TYPE.MONTH : CAL_TYPE.WEEK));
  }, [type]);

  return (
    <section className="schedule-calendar">
      <Header l10n={l10n} />
      <div className="calendar-content">
        {type === CAL_TYPE.WEEK ? (
          <Week dataByDateMap={dataByDateMap} isShowCalendarMark={isShowCalendarMark} />
        ) : (
          <Month dataByDateMap={dataByDateMap} isShowCalendarMark={isShowCalendarMark} />
        )}
      </div>
      {!isPc ? (
        <div className="btn-calendar-wrap">
          <button
            type="button"
            className={`btn-calendar ${type === CAL_TYPE.WEEK ? 'fold' : ''}`}
            onClick={btnClickCallback}
            data-contents="달력_달력확장_클릭"
          >
            <span className="hidden">{l10n?.calendar?.btnCalendarText}</span>
            <span className="btn-calendar-icon"></span>
          </button>
        </div>
      ) : (
        <Fragment />
      )}
    </section>
  );
};

export default Calendar;
